var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRightGreen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00A32E",
  d: "m5.92 2.104-.99.979 5.886 5.926-5.936 5.877.981.988 6.925-6.856z"
})));
export { SvgArrowRightGreen as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IiYjMjMxOyYjMTc0OyYjMTczOyYjMjI5OyYjMTY0OyYjMTgwOyAyIj4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTUuOTE5MTMgMi4xMDM1Mkw0LjkyOTg3IDMuMDgyOTdMMTAuODE2IDkuMDA5NUw0Ljg4MDM3IDE0Ljg4NjFMNS44NjEyNyAxNS44NzM3TDEyLjc4NjEgOS4wMTc1N0w1LjkxOTEzIDIuMTAzNTJaIiBmaWxsPSIjMDBBMzJFIi8+CjwvZz4KPC9zdmc+Cg==";